export default {
  attacksByTimestamp(state, getters, rootState) {
    const { events } = state;
    const { unixTs } = rootState;

    const eventsArr = [];
    let index = events?.findIndex(o => o.timestamp === unixTs);
    if (!index || index === -1) {
      return eventsArr;
    }
    while (events[index]?.timestamp === unixTs) {
      eventsArr.push({ ...events[index] });
      index += 1;
    }
    return eventsArr;
  },
  top5Attackers(state) {
    const shallowPastEvents = [...state.pastEvents];
    shallowPastEvents.sort((a, b) => {
      return b.sum - a.sum;
    });

    const top5 = shallowPastEvents.slice(0, 5);
    return top5;
  },
  totalAttackByActiveCountry(state, getters, rootState) {
    const {
      mapStore: {
        countries: { details, activeCountryId }
      }
    } = rootState;

    if (!activeCountryId) {
      return null;
    }

    const country = details.find(o => o.id === activeCountryId);
    if (!country) {
      return null;
    }
    const { cId } = country;

    return state.pastEvents.find(o => o.geocountry === cId)?.sum;
  },
  totalAttacks(state) {
    return state.eventCount;
  }
};
